import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "input-box"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ChatInput = _resolveComponent("ChatInput")

  return (!$props.readonly)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ChatInput, {
          ref: "input",
          modelValue: $data.input_text,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.input_text) = $event)),
          description: "Genrate can make mistakes. Consider checking important information.",
          controls: _ctx.$responsive.desktop,
          placeholder: _ctx.$responsive.mobile ? 'Ask anything...' : 'Ask anything, or type / to run a skill…',
          question: $options.ai_question,
          "chat-id": $props.chatId,
          generating: $props.generating,
          onRegenerate: _cache[1] || (_cache[1] = $event => (_ctx.$emit('regenerate', $event))),
          onStop: $options.onStop,
          onResize: _cache[2] || (_cache[2] = $event => (_ctx.$emit('resize')))
        }, null, 8 /* PROPS */, ["modelValue", "controls", "placeholder", "question", "chat-id", "generating", "onStop"])
      ]))
    : _createCommentVNode("v-if", true)
}